import './_search-input.scss';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button, Glyphicon } from 'react-bootstrap';

const SearchInput = ({ placeholder, optionSelected, onSubmit, showButton, options, style, disabled, value, onChange, onChangeOption, ...props }) => {
  const Tag = showButton ? 'form' : 'div';

  return (
    <Tag
      onSubmit={onSubmit || null}
      className={classNames('search-input', {
        'search-input__with-select': !!options.length,
        'search-input__with-select-button': showButton,
      })}
      style={style}
    >
      <label htmlFor="searchInput" className="search-input__icon">
        <span className="fas fa-search" />
      </label>
      <input
        disabled={disabled}
        type="text"
        id="searchInput"
        value={value}
        placeholder={placeholder}
        className="form-control search-input__input"
        onChange={onChange}
        {...props}
      />
      {options.length
        ? (
          <div className="search-input__select">
            <select
              disabled={disabled}
              className="form-control"
              value={optionSelected || ''}
              onChange={onChangeOption}
            >
              {options.map((option, index) => (
                <option value={option.value} key={index}>{option.name}</option>
              ))}
            </select>
          </div>
        ) : null}
      {showButton
        ? (
          <Button className="custom__search-button" type="submit" disabled={disabled}>
            <Glyphicon glyph="search" />
          </Button>
        ) : null}
    </Tag>
  );
}

SearchInput.defaultProps = {
  placeholder: '',
  value: '',
  options: [],
  showButton: false,
  disabled: false,
};

SearchInput.propTypes = {
  placeholder: PropTypes.string,
  optionSelected: PropTypes.string,
  options: PropTypes.array,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
  onChangeOption: PropTypes.func,
  showButton: PropTypes.bool,
  onSubmit: PropTypes.func,
  disabled: PropTypes.bool,
  style: PropTypes.object,
};

export default SearchInput;
